module.exports = __webpack_public_path__ + "img/antes_despues_179.9f9a1925.png";